import React from 'react';
import { useNetworkStatus } from '../../hooks/useMobile';

const NetworkStatus: React.FC = () => {
  const { isOnline, connectionType } = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div className="network-status show">
      <div className="flex items-center justify-center space-x-2">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M18.364 5.636l-12.728 12.728m0 0L12 12m-6.364 6.364L12 12m6.364-6.364L12 12" 
          />
        </svg>
        <span>网络连接已断开，请检查网络设置</span>
      </div>
    </div>
  );
};

export default NetworkStatus;